import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../images/tab-1.jpg'
import _imports_1 from '../images/tab-1-mobile.jpg'


const _withScopeId = n => (_pushScopeId("data-v-c2f8c5c4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container page" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "page-image d-none d-md-block"
}, null, -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  class: "page-image d-block d-md-none"
}, null, -1))
const _hoisted_4 = { class: "button-wrapper" }

import { onMounted } from 'vue';
  import NextButton from './next-button.vue';

  
export default /*#__PURE__*/_defineComponent({
  setup(__props) {

  onMounted(() => {});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _createElementVNode("div", _hoisted_4, [
      _createVNode(NextButton)
    ])
  ]))
}
}

})